nifty.document.ready(function () {

    $('.datetimepicker, .datetimerangepicker, .daterangeeuridpicker').each(function () {
        let date = $(this).val();
        let dateFormat = $(this).data('date-format');
        let isValid = moment(date).isValid();
        if (isValid) {
            let newDate = moment(date).format(dateFormat);
            if (date !== newDate)
                $(this).val(newDate)
        }
    });

    $('.datetimerangepicker-trigger').click(function () {
            $(this).parents(".input-group").find(".datetimerangepicker").click();
        }
    );

    $('.daterangeeuridpicker').each(function () {
        let parentElSelector = $(this).closest('.modal').length ? $(this).closest('.modal')[0] : 'body'
        let endDate = $("#id_" + $(this).attr('data-enddate-field')).val() ? $("#id_" + $(this).attr('data-enddate-field')).val() : $(this).data('min-date') || moment().endOf('day')

        if($(this).attr('data-min-days-range')){
            endDate = moment(endDate).add($(this).attr('data-min-days-range'), 'days').format($(this).attr('data-date-format'))
        }

        $(this).daterangepicker({
            autoUpdateInput: false,
            timePicker: false,
            timePicker24Hour: false,
            parentEl: parentElSelector,
            timePickerIncrement: 1,
            cancelClass: "btn-danger",
            minDate: $(this).data('min-date') || null,
            maxDate: $(this).data('max-date') || moment().add(10, 'years'),
            locale: {
                "format": $(this).data('date-format'),
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": moment.weekdaysShort(),
                "monthNames": moment.months(),
                "firstDay": 1,
            },
            startDate: $("#id_" + $(this).attr('data-startdate-field')).val() ? $("#id_" + $(this).attr('data-startdate-field')).val() : moment().startOf('day'),
            endDate: endDate,
            ...$(this).attr('data-max-days-range') ? {maxSpan: {days: $(this).attr('data-max-days-range')}} : {},
            ...$(this).attr('data-min-days-range') ? {minSpan: {days: $(this).attr('data-min-days-range')}} : {}
        })
    });

    $('.datetimerangepicker').each(function () {
        let parentElSelector = $(this).closest('.modal').length ? $(this).closest('.modal')[0] : 'body'

        $(this).daterangepicker({
            autoUpdateInput: false,
            timePicker: true,
            timePicker24Hour: true,
            parentEl: parentElSelector,
            timePickerIncrement: 1,
            cancelClass: "btn-danger",
            minDate: $(this).data('min-date') || null,
            maxDate: $(this).data('max-date') || moment().add(10, 'years'),
            locale: {
                "format": $(this).data('date-format'),
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": moment.weekdaysShort(),
                "monthNames": moment.months(),
                "firstDay": 1,
            },
            startDate: $("#id_" + $(this).attr('data-startdate-field')).val() ? $("#id_" + $(this).attr('data-startdate-field')).val() : moment().startOf('day'),
            endDate: $("#id_" + $(this).attr('data-enddate-field')).val() ? $("#id_" + $(this).attr('data-startdate-field')).val() : moment().endOf('day'),
            maxSpan: {days: $(this).attr('data-max-days-range')}
        })
    });

    $('body').on('show.daterangepicker', '.datetimerangepicker, .daterangeeuridpicker', function (ev, picker) {
        let startDateVal = $("#id_" + $(this).attr('data-startdate-field')).val()
        let endDateVal = $("#id_" + $(this).attr('data-enddate-field')).val()

        if(startDateVal)
            picker.setStartDate($("#id_" + $(this).attr('data-startdate-field')).val())

        if(endDateVal)
            picker.setEndDate($("#id_" + $(this).attr('data-enddate-field')).val())

        if(startDateVal || endDateVal)
            picker.updateView();

    })

    $('body').on(
		'focus.datepicker.data-api click.datepicker.data-api',
		'[data-provide="datepicker"]',
		function(e){
            if($(this).prop("disabled") || $(this).is("[readonly]")){
                e.preventDefault();
            }
        }
    )

    $('body').on('apply.daterangepicker', '.datetimerangepicker, .daterangeeuridpicker', function (ev, picker) {
        $("#id_" + $(this).attr('data-startdate-field')).val(picker.startDate.format($(this).attr('data-date-format')));
        $("#id_" + $(this).attr('data-enddate-field')).val(picker.endDate.format($(this).attr('data-date-format')));
    });

    /* Date picker */
    $('.datepicker').each(function () {
        let parentElSelector = $(this).closest('.modal').length ? $(this).closest('.modal')[0] : 'body'
        $(this).daterangepicker({
            autoUpdateInput: false,
            cancelClass: "btn-danger",
            singleDatePicker: true,
            parentEl: parentElSelector,
            minDate: $(this).data('min-date') || null,
            maxDate: $(this).data('max-date') || moment().add(10, 'years'),
            locale: {
                "format": $(this).data('date-format'),
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": moment.weekdaysShort(),
                "monthNames": moment.months(),
                "firstDay": 1,
            }
        })
    });

    $('.datepicker-trigger').click(function () {
            let $datepicker = $(this).parents(".input-group").find(".datepicker")
            if(!$datepicker.prop("disabled") && !$datepicker.is("[readonly]")) {
                $datepicker.click();
            }
        }
    );

    $('body').on('click', '.daterangepicker-trigger', function () {
            let $datepicker = $(this).parents(".input-group").find(".daterangeeuridpicker")
            if(!$datepicker.prop("disabled") && !$datepicker.is("[readonly]")) {
                $datepicker.click();
            }
        }
    );

    $('.datepicker').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format($(this).attr('data-date-format')));
        $(this).trigger('input');
    });

    /* Month picker */
    $('.monthpicker').datepicker({
        startView: 1,
        minViewMode: 1
    });

    $('.monthpicker-trigger').click(function () {
        $(this).parents(".input-group").find(".monthpicker").focus();
    });

    /* Date time picker */
    $('.datetimepicker').each(function(){
        // if you don't select the element $(this).closest('.modal')[0] , the library will apply a jquery selector and get the first element as parent
        let parentElSelector = $(this).closest('.modal').length ? $(this).closest('.modal')[0] : 'body'
        $(this).daterangepicker(
        {
            autoUpdateInput: false,
            cancelClass: "btn-danger",
            singleDatePicker: true,
            showDropdowns: true,
            parentEl: parentElSelector,
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            maxDate: moment().add(10, 'years'),
            locale: {
                "format": $(this).data('date-format'),
                "separator": " - ",
                "applyLabel": "Apply",
                "cancelLabel": "Cancel",
                "fromLabel": "From",
                "toLabel": "To",
                "customRangeLabel": "Custom",
                "weekLabel": "W",
                "daysOfWeek": moment.weekdaysShort(),
                "monthNames": moment.months(),
                "firstDay": 1,
            }
        }
    )});

    $('.datetimepicker').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format($(this).attr('data-date-format')));
    });

    $('.datetimepicker-trigger').click(function () {
            $(this).parents(".input-group").find(".datetimepicker").click();
        }
    );
    $(document).keyup(function (e) {
        if (e.keyCode == 27) {
            $('.daterangepicker').css('display', 'none');
        }
    });
});

